// Distribution du bandit manchot : les personnages des deux premiers rouleaux et les actions du
// troisième. Le libellé et la phrase de chaque action sont dans data/translations.js (slot.action.<id>).
// Personnages : uniquement des têtes vues de face (ni animal entier, ni profil), sans expression
// (pas de chats ni de singes expressifs), pour qu'ils se ressemblent dans le labyrinthe.
// 🐻‍❄️ (2020) et 🫎 (2022) manquent aux systèmes plus anciens.
export const CHARACTERS = Object.freeze([
  // Animaux
  '🐭', '🐹', '🐰', '🐱', '🐶', '🦊', '🐻', '🐻‍❄️', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🫎', '🐲',
  // Têtes fantastiques
  '🤖', '👽', '👹', '🤡', '💀',
]);

export const ACTIONS = Object.freeze([
  { id: 'love', emoji: '❤️' },
  { id: 'fight', emoji: '🥊' },
  { id: 'kiss', emoji: '💋' },
  { id: 'hug', emoji: '🤗' },
  { id: 'scare', emoji: '😱' },
  { id: 'tickle', emoji: '🪶' },
  { id: 'dance', emoji: '🎶' },
]);

// Distribution tant que le bandit n'a pas encore tourné : la souris, le chat, aimer
export const DEFAULT_CAST = Object.freeze({ player: '🐭', rival: '🐱', action: ACTIONS[0] });
